import React from "react";
import { SERVICES_CHIPS } from "../constants/ourServicesIcons";
import "./Services.css";

const Services = () => {
  const sectionTitle = "Our Event Solutions";

  return (
    <section id="services" className="services">
      <div className="services-container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle services-subtitle">{sectionTitle}</p>
        </div>
        <div className="services-chips-grid">
          {SERVICES_CHIPS.map(({ title, icon }) => (
            <div key={title} className="service-chip">
              <span className="service-chip-label">{title}</span>
              <div className="service-chip-icon-wrap">
                <img
                  src={icon}
                  alt={title}
                  className="service-chip-icon"
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
